import React, { useRef } from 'react';
import {
  AppBar,
  Toolbar,
  Drawer,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Tabs,
  Tab,
  Divider,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Actions, useDispatchProvider, useStateDrawerUser, useStateTabsUsers } from '../utils/StateProvider';
import FormUser from '../forms/FormUser';
import { usePermissions } from '../utils/AclProvider';
import ListUserTransactions from '../lists/ListUserTransactions';

const DrawerUser = () => {
  const portalRef = useRef(null);
  const stateDrawerUser = useStateDrawerUser();
  const stateTabsUsers = useStateTabsUsers();
  const permissions = usePermissions();
  const dispatch = useDispatchProvider();
  const handleDrawerClose = () => {
    dispatch && dispatch({ type: Actions.DrawerUser, payload: false });
  };
  const handleChangeTab = (event, newValue) => {
    dispatch && dispatch({ type: Actions.TabsUser, payload: newValue });
  };
  return (
    <Drawer
      open={stateDrawerUser}
      onClose={handleDrawerClose}
      anchor={'bottom'}
      color={'background'}
      elevation={0}
      sx={{
        '& .MuiDrawer-paper': {
          height: '100dvh',
        },
      }}
    >
      <AppBar position={'sticky'}>
        <Toolbar>
          <IconButton
            autoFocus
            size="large"
            edge="start"
            color="inherit"
            aria-label="close"
            sx={{ mr: 2 }}
            onClick={handleDrawerClose}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            User Details
          </Typography>
        </Toolbar>
      </AppBar>
      <AppBar
        elevation={0}
        position={'sticky'}
        color={'transparent'}
      >
        <Toolbar>
          <Tabs
            value={stateTabsUsers}
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
          >
            <Tab
              label="Information"
              value="form"
              sx={{ height: 64 }}
            />
            <Tab
              label="Orders"
              value="orders"
              sx={{ height: 64 }}
            />
            {permissions?.transactions?.read && (
              <Tab
                label="Τransactions"
                value="transactions"
                sx={{ height: 64 }}
              />
            )}
          </Tabs>
        </Toolbar>
        <Divider />
      </AppBar>
      {stateTabsUsers === 'form' && (
        <DialogContent dividers={true}>
          <Card elevation={1}>
            <CardContent>
              <FormUser portalRef={portalRef} />
            </CardContent>
          </Card>
        </DialogContent>
      )}
      {stateTabsUsers === 'orders' && <DialogContent dividers={true}>TBD</DialogContent>}
      {stateTabsUsers === 'transactions' && (
        <DialogContent dividers={true}>
          <ListUserTransactions portalRef={portalRef} />
        </DialogContent>
      )}
      <DialogActions
        sx={{ paddingX: 3, paddingY: 2 }}
        ref={portalRef}
      ></DialogActions>
    </Drawer>
  );
};

export default DrawerUser;
